export interface TvShow {
  id: number;
  name: string;
  englishName: string;
  category: string;
  categorySlug: string;
  poster: string;
  rating: number;
  year: number;
  episodes: number;
  currentEpisode: number;
  status: 'updating' | 'completed';
  description: string;
  actors: string[];
  director: string;
  region: string;
  tags: string[];
  featured: boolean;
  updateInfo: string;
  totalViews: string;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '国产剧', slug: 'guochanju' },
  { name: '韩剧', slug: 'hanju' },
  { name: '美剧', slug: 'meiju' },
  { name: '日剧', slug: 'riju' },
  { name: '泰剧', slug: 'taiju' },
  { name: '动漫', slug: 'dongman' },
];

export const tvShows: TvShow[] = [
  {
    id: 1,
    name: '长风渡',
    englishName: 'Destined',
    category: '国产剧',
    categorySlug: 'guochanju',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20elegant%20couple%20in%20traditional%20hanfu%20costume%2C%20soft%20warm%20lighting%2C%20ancient%20Chinese%20architecture%20background%2C%20cinematic%20composition%2C%20film%20poster%20style%2C%20dramatic%20mood&width=600&height=800&seq=mock-poster-01&orientation=portrait',
    rating: 8.5,
    year: 2023,
    episodes: 40,
    currentEpisode: 40,
    status: 'completed',
    description: '布商之女柳玉茹自小遭遇生母病重、庶母不慈、父亲不重视的困境，她不得已谨小慎 micro，做了十几年模范闺秀。不料，对婚姻抱有憧憬的她却被家里安排嫁给了名满扬州的纨绔顾九思。顾九思误会柳玉茹是因为攀附权贵才嫁给他，对其嗤之以鼻。柳玉茹幡然醒悟，不能将命运系之婚姻、系之他人，决定跟随顾母学习经商之道，真实、独立、精彩地实现自我价值。',
    actors: ['白敬亭', '宋轶', '刘学义', '张昊唯', '张瑞'],
    director: '尹涛',
    region: '中国大陆',
    tags: ['古装', '爱情', '励志', '商战'],
    featured: true,
    updateInfo: '已完结 · 全40集',
    totalViews: '12.8亿',
  },
  {
    id: 2,
    name: '狂飙',
    englishName: 'The Knockout',
    category: '国产剧',
    categorySlug: 'guochanju',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20poster%20with%20intense%20male%20lead%20in%20dark%20atmosphere%2C%20police%20and%20gangster%20theme%2C%20noir%20lighting%2C%20cinematic%20film%20poster%2C%20dramatic%20tension&width=600&height=800&seq=mock-poster-02&orientation=portrait',
    rating: 9.1,
    year: 2023,
    episodes: 39,
    currentEpisode: 39,
    status: 'completed',
    description: '京海市一线刑警安欣，在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海，联合公检法司各部门，清除了政法队伍内部的腐败分子，粉碎了黑恶势力的保护伞，一举铲除了盘踞京海多年的强盛集团。',
    actors: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
    director: '徐纪周',
    region: '中国大陆',
    tags: ['刑侦', '扫黑', '悬疑', '剧情'],
    featured: true,
    updateInfo: '已完结 · 全39集',
    totalViews: '25.3亿',
  },
  {
    id: 3,
    name: '黑暗荣耀',
    englishName: 'The Glory',
    category: '韩剧',
    categorySlug: 'hanju',
    poster: 'https://readdy.ai/api/search-image?query=Korean%20revenge%20drama%20poster%20with%20elegant%20female%20lead%20in%20dark%20sophisticated%20style%2C%20mysterious%20atmosphere%2C%20minimalist%20Korean%20film%20poster%20design%2C%20cold%20color%20tone&width=600&height=800&seq=mock-poster-03&orientation=portrait',
    rating: 8.9,
    year: 2022,
    episodes: 16,
    currentEpisode: 16,
    status: 'completed',
    description: '梦想成为一名建筑师的文东恩，高中时期因遭受校园暴力而不得不退学。随后她通过自学考上了大学，并成为了一名小学教师。多年后，当年加害她主谋的女儿成为了文东恩的学生，一场筹备多年的复仇计划就此展开。',
    actors: ['宋慧乔', '李到晛', '林智妍', '郑成日'],
    director: '安吉镐',
    region: '韩国',
    tags: ['复仇', '校园暴力', '悬疑', '剧情'],
    featured: true,
    updateInfo: '已完结 · 全16集',
    totalViews: '8.2亿',
  },
  {
    id: 4,
    name: '庆余年第二季',
    englishName: 'Joy of Life S2',
    category: '国产剧',
    categorySlug: 'guochanju',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20historical%20drama%20poster%20with%20male%20protagonist%20in%20traditional%20robe%2C%20epic%20palace%20background%2C%20dramatic%20lighting%2C%20grand%20film%20poster%20style&width=600&height=800&seq=mock-poster-04&orientation=portrait',
    rating: 8.7,
    year: 2024,
    episodes: 36,
    currentEpisode: 30,
    status: 'updating',
    description: '范闲率使团回归途中，二皇子以费介、范思辙以及滕家遗孤的安危来威胁范闲，逼他向自己俯首称臣，二人的矛盾就此激发。范闲所面对的抱月楼迷局，以及接踵而至的春闱危机，都是二皇子精心给范闲布下的陷阱。',
    actors: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    director: '孙皓',
    region: '中国大陆',
    tags: ['古装', '权谋', '奇幻', '喜剧'],
    featured: true,
    updateInfo: '更新至30集/共36集',
    totalViews: '18.6亿',
  },
  {
    id: 5,
    name: '眼泪女王',
    englishName: 'Queen of Tears',
    category: '韩剧',
    categorySlug: 'hanju',
    poster: 'https://readdy.ai/api/search-image?query=Korean%20romantic%20comedy%20drama%20poster%20with%20elegant%20couple%20in%20luxury%20setting%2C%20soft%20romantic%20lighting%2C%20fashionable%20Korean%20drama%20poster%20style&width=600&height=800&seq=mock-poster-05&orientation=portrait',
    rating: 8.3,
    year: 2024,
    episodes: 16,
    currentEpisode: 12,
    status: 'updating',
    description: '百货女王洪海仁与超市王子白贤宇，这对财阀夫妇在经历了三年婚姻后，面对种种危机，最终重新开始谱写奇迹般的爱情故事。',
    actors: ['金秀贤', '金智媛', '朴成焄', '郭东延'],
    director: '张英宇',
    region: '韩国',
    tags: ['爱情', '喜剧', '财阀', '治愈'],
    featured: false,
    updateInfo: '更新至12集/共16集',
    totalViews: '6.8亿',
  },
  {
    id: 6,
    name: '权力的游戏',
    englishName: 'Game of Thrones',
    category: '美剧',
    categorySlug: 'meiju',
    poster: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20drama%20poster%20with%20iron%20throne%20silhouette%2C%20dark%20medieval%20atmosphere%2C%20dragon%20shadow%2C%20cinematic%20HBO%20style%20poster%2C%20dramatic%20lighting&width=600&height=800&seq=mock-poster-06&orientation=portrait',
    rating: 9.4,
    year: 2011,
    episodes: 73,
    currentEpisode: 73,
    status: 'completed',
    description: '维斯特洛大陆上几大家族争夺铁王座的权力斗争，以及北方绝境长城之外的超自然威胁。史塔克家族、兰尼斯特家族、坦格利安家族的命运交织在一起，展开了一场史诗般的权力游戏。',
    actors: ['艾米莉亚·克拉克', '基特·哈灵顿', '彼特·丁拉基', '琳娜·海蒂'],
    director: '大卫·贝尼奥夫',
    region: '美国',
    tags: ['奇幻', '史诗', '战争', '权谋'],
    featured: false,
    updateInfo: '已完结 · 全8季73集',
    totalViews: '15.2亿',
  },
  {
    id: 7,
    name: '莲花楼',
    englishName: 'Mysterious Lotus Casebook',
    category: '国产剧',
    categorySlug: 'guochanju',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20mystery%20drama%20poster%20with%20swordsman%20in%20flowing%20robe%2C%20ancient%20Chinese%20landscape%20with%20lotus%20pond%2C%20wuxia%20film%20poster%20style&width=600&height=800&seq=mock-poster-07&orientation=portrait',
    rating: 8.6,
    year: 2023,
    episodes: 40,
    currentEpisode: 40,
    status: 'completed',
    description: '闻名武林的四顾门门主李相夷在一次大战后身受重伤，从此退隐江湖成为淡泊名利的郎中李莲花。在遇到新交方多病与旧敌笛飞声后，三人组成探案组合，携手破获了一桩桩江湖奇案。',
    actors: ['成毅', '曾舜晞', '肖顺尧', '陈都灵'],
    director: '郭虎',
    region: '中国大陆',
    tags: ['武侠', '探案', '古装', '悬疑'],
    featured: false,
    updateInfo: '已完结 · 全40集',
    totalViews: '9.5亿',
  },
  {
    id: 8,
    name: '怪奇物语',
    englishName: 'Stranger Things',
    category: '美剧',
    categorySlug: 'meiju',
    poster: 'https://readdy.ai/api/search-image?query=80s%20retro%20sci-fi%20horror%20drama%20poster%20with%20kids%20on%20bikes%2C%20neon%20red%20title%2C%20dark%20supernatural%20atmosphere%2C%20Netflix%20style%20poster%2C%20nostalgic%20vibe&width=600&height=800&seq=mock-poster-08&orientation=portrait',
    rating: 9.0,
    year: 2016,
    episodes: 34,
    currentEpisode: 34,
    status: 'completed',
    description: '在1980年代的印第安纳州霍金斯小镇，一名小男孩神秘失踪。他的朋友、家人和当地警察开始寻找答案，却卷入了一个涉及秘密政府实验、超自然力量和另一个维度世界的惊天谜团。',
    actors: ['米莉·波比·布朗', '芬恩·伍法德', '薇诺娜·瑞德', '大卫·哈伯'],
    director: '达菲兄弟',
    region: '美国',
    tags: ['科幻', '恐怖', '悬疑', '怀旧'],
    featured: false,
    updateInfo: '已完结 · 全4季34集',
    totalViews: '10.1亿',
  },
  {
    id: 9,
    name: '重启人生',
    englishName: 'Brush Up Life',
    category: '日剧',
    categorySlug: 'riju',
    poster: 'https://readdy.ai/api/search-image?query=Japanese%20slice%20of%20life%20comedy%20drama%20poster%20with%20three%20female%20friends%20laughing%2C%20warm%20everyday%20atmosphere%2C%20Japanese%20TV%20drama%20poster%20style%2C%20bright%20natural%20lighting&width=600&height=800&seq=mock-poster-09&orientation=portrait',
    rating: 9.3,
    year: 2023,
    episodes: 10,
    currentEpisode: 10,
    status: 'completed',
    description: '近藤麻美是一名普通的公务员，在33岁那年意外去世。当她来到死后世界，被告知可以选择投胎成为食蚁兽，或者重新活一遍自己的人生以积攒足够的阴德来投胎做人。于是，麻美开始了她一次又一次的重启人生。',
    actors: ['安藤樱', '夏帆', '木南晴夏', '松坂桃李'],
    director: '水野格',
    region: '日本',
    tags: ['奇幻', '喜剧', '温情', '日常'],
    featured: false,
    updateInfo: '已完结 · 全10集',
    totalViews: '3.2亿',
  },
  {
    id: 10,
    name: '长相思',
    englishName: 'Lost You Forever',
    category: '国产剧',
    categorySlug: 'guochanju',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20poster%20with%20beautiful%20female%20lead%20in%20ancient%20goddess%20costume%2C%20mythical%20Chinese%20atmosphere%2C%20ethereal%20lighting%2C%20dreamy%20film%20poster&width=600&height=800&seq=mock-poster-10&orientation=portrait',
    rating: 8.4,
    year: 2023,
    episodes: 39,
    currentEpisode: 39,
    status: 'completed',
    description: '上古时期，人、神、妖混居，神农、轩辕、高辛三国鼎立。流落大荒的高辛王姬玖瑶历经百年颠沛之苦，不但失去了身份，也失去了容貌，在清水镇落脚，成为了无处可去、无人可依、无力自保的玟小六。',
    actors: ['杨紫', '张晚意', '邓为', '檀健次'],
    director: '秦榛',
    region: '中国大陆',
    tags: ['古装', '神话', '爱情', '奇幻'],
    featured: false,
    updateInfo: '已完结 · 全39集',
    totalViews: '16.4亿',
  },
  {
    id: 11,
    name: '与恶魔有约',
    englishName: 'My Demon',
    category: '韩剧',
    categorySlug: 'hanju',
    poster: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20drama%20poster%20with%20devilishly%20handsome%20male%20lead%20and%20elegant%20female%20lead%2C%20dark%20romantic%20atmosphere%2C%20supernatural%20Korean%20drama%20style&width=600&height=800&seq=mock-poster-11&orientation=portrait',
    rating: 8.0,
    year: 2023,
    episodes: 16,
    currentEpisode: 16,
    status: 'completed',
    description: '无情的恶魔郑九元与高傲的财阀继承人都到曦签订契约婚姻后，展开了一段奇幻浪漫的爱情故事。恶魔在失去能力后，不得不与这个讨厌的女人共同生活。',
    actors: ['金裕贞', '宋江', '李相二', '金海淑'],
    director: '金章汉',
    region: '韩国',
    tags: ['奇幻', '爱情', '喜剧', '契约婚姻'],
    featured: false,
    updateInfo: '已完结 · 全16集',
    totalViews: '5.6亿',
  },
  {
    id: 12,
    name: '绝命毒师',
    englishName: 'Breaking Bad',
    category: '美剧',
    categorySlug: 'meiju',
    poster: 'https://readdy.ai/api/search-image?query=American%20crime%20drama%20poster%20with%20middle-aged%20man%20in%20desert%20landscape%2C%20chemical%20symbols%2C%20dark%20gritty%20atmosphere%2C%20award-winning%20TV%20series%20poster%20style&width=600&height=800&seq=mock-poster-12&orientation=portrait',
    rating: 9.5,
    year: 2008,
    episodes: 62,
    currentEpisode: 62,
    status: 'completed',
    description: '一位普通的高中化学老师沃尔特·怀特在得知自己身患绝症之后，为了给家人留下财产，利用自己超凡的化学知识制造毒品，从此踏入了危险的犯罪世界。他逐渐从一个善良的普通人变成了冷酷无情的大毒枭海森堡。',
    actors: ['布莱恩·科兰斯顿', '亚伦·保尔', '安娜·冈', '迪恩·诺里斯'],
    director: '文斯·吉里根',
    region: '美国',
    tags: ['犯罪', '剧情', '惊悚', '黑色幽默'],
    featured: false,
    updateInfo: '已完结 · 全5季62集',
    totalViews: '15.8亿',
  },
  {
    id: 13,
    name: '繁花',
    englishName: 'Blossoms Shanghai',
    category: '国产剧',
    categorySlug: 'guochanju',
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20set%20in%201990s%20Shanghai%2C%20retro%20aesthetic%2C%20neon%20lights%2C%20fashionable%20characters%2C%20Wong%20Kar-wai%20style%20cinematography%2C%20nostalgic%20film%20poster&width=600&height=800&seq=mock-poster-13&orientation=portrait',
    rating: 8.8,
    year: 2023,
    episodes: 30,
    currentEpisode: 30,
    status: 'completed',
    description: '九十年代的上海，处处是机遇与希望。青年阿宝凭借改革开放的春风和自己的打拼，成为商界后起之秀。黄河路上人来人往，每个人都有各自的故事和命运。这是一部关于上海、关于那个年代的繁华与变迁的故事。',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    director: '王家卫',
    region: '中国大陆',
    tags: ['年代', '商战', '爱情', '上海'],
    featured: true,
    updateInfo: '已完结 · 全30集',
    totalViews: '19.7亿',
  },
  {
    id: 14,
    name: '进击的巨人',
    englishName: 'Attack on Titan',
    category: '动漫',
    categorySlug: 'dongman',
    poster: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20giant%20titan%20and%20survey%20corps%20soldiers%2C%20epic%20action%20scene%2C%20dark%20dramatic%20atmosphere%2C%20anime%20film%20poster%20style&width=600&height=800&seq=mock-poster-14&orientation=portrait',
    rating: 9.2,
    year: 2013,
    episodes: 87,
    currentEpisode: 87,
    status: 'completed',
    description: '在一个被巨人支配的世界里，人类被迫生活在巨大的城墙之内。少年艾伦·耶格尔目睹母亲被巨人吞噬后，立誓要消灭所有巨人。他加入了调查兵团，逐渐揭开了巨人和这个世界背后隐藏的巨大秘密。',
    actors: ['梶裕贵', '石川由依', '井上麻里奈'],
    director: '荒木哲郎',
    region: '日本',
    tags: ['热血', '战斗', '悬疑', '末日'],
    featured: false,
    updateInfo: '已完结 · 全87集',
    totalViews: '22.1亿',
  },
  {
    id: 15,
    name: '天生一对',
    englishName: 'Love Destiny',
    category: '泰剧',
    categorySlug: 'taiju',
    poster: 'https://readdy.ai/api/search-image?query=Thai%20historical%20romance%20drama%20poster%20with%20couple%20in%20traditional%20Thai%20costume%2C%20ancient%20Ayutthaya%20setting%2C%20warm%20golden%20lighting%2C%20Thai%20drama%20poster%20style&width=600&height=800&seq=mock-poster-15&orientation=portrait',
    rating: 8.1,
    year: 2018,
    episodes: 15,
    currentEpisode: 15,
    status: 'completed',
    description: '现代胖女孩Karaked遭遇车祸后，灵魂穿越到了古代阿瑜陀耶王朝，附身在一个叫Karakade的恶毒大小姐身上。她凭借现代人的智慧和善良，逐渐改变身边人对她的看法，并与男主角展开了一段跨越时空的爱情。',
    actors: ['Pope Thanawat', 'Bella Ranee'],
    director: 'Pawat Panangkasiri',
    region: '泰国',
    tags: ['穿越', '古装', '爱情', '喜剧'],
    featured: false,
    updateInfo: '已完结 · 全15集',
    totalViews: '4.5亿',
  },
  {
    id: 16,
    name: '咒术回战',
    englishName: 'Jujutsu Kaisen',
    category: '动漫',
    categorySlug: 'dongman',
    poster: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20sorcerer%20characters%20fighting%20cursed%20spirits%2C%20dynamic%20action%20pose%2C%20urban%20fantasy%20setting%2C%20modern%20anime%20film%20poster%20style&width=600&height=800&seq=mock-poster-16&orientation=portrait',
    rating: 8.9,
    year: 2020,
    episodes: 47,
    currentEpisode: 47,
    status: 'completed',
    description: '高中生虎杖悠仁偶然吞下了诅咒之王两面宿傩的手指，成为了宿傩的容器。为了收集散落各地的宿傩手指，他加入了专门对抗诅咒的东京都立咒术高等专门学校，与伙伴们一起踏上了咒术师的战斗之路。',
    actors: ['榎木淳弥', '内田雄马', '濑户麻沙美'],
    director: '朴性厚',
    region: '日本',
    tags: ['热血', '战斗', '校园', '超能力'],
    featured: false,
    updateInfo: '已完结 · 全2季47集',
    totalViews: '11.3亿',
  },
];

export const rankings = {
  hot: [1, 3, 2, 13, 4, 7, 10, 5, 6, 8],
  rating: [12, 6, 9, 14, 2, 16, 3, 13, 4, 1],
};